import { create } from "zustand";

interface Product {
  id?: number;
  productId: number;
  variantId: number;
  quantity: number;
  productName: string;
  image: string;
  originalPrice: number;
  salePrice: number;
  unitCounting?: string;
  stockThreshold?: number;
}

interface CartStore {
  productCard: Product[];
  addToCard: (item: Product) => void;
  updateQuantity: (
    productId: number,
    variantId: number,
    quantity: number,
    stockThreshold: number
  ) => void;
  removeFromCard: (variantId: number) => void;
  loadCard: () => void;
  clearCard: () => void;
}

const useCartStore = create<CartStore>((set, get) => ({
  productCard: [],
  addToCard: (item) => {
    const currentCard = get().productCard;
    const updatedCard = [...currentCard, item];
    set({ productCard: updatedCard });
    localStorage.setItem("productCard", JSON.stringify(updatedCard));
  },
  updateQuantity: (productId, variantId, quantity, stockThreshold) => {
    const currentCard = get().productCard;
    const updatedCard = currentCard.map((item) => {
      if (item.productId === productId && item.variantId === variantId) {
        return { ...item, quantity, stockThreshold };
      }
      return item;
    });
    set({ productCard: updatedCard });
    localStorage.setItem("productCard", JSON.stringify(updatedCard));
  },
  removeFromCard: (variantId: number) => {
    const currentCard = get().productCard;
    const updatedCard = currentCard.filter(
      (item) => item.variantId !== variantId
    );
    set({ productCard: updatedCard });
    localStorage.setItem("productCard", JSON.stringify(updatedCard));
  },
  loadCard: () => {
    const storedCard = localStorage.getItem("productCard");
    if (storedCard) {
      set({ productCard: JSON.parse(storedCard) });
    }
  },
  clearCard: () => {
    set({ productCard: [] });
    localStorage.removeItem("productCard");
  },
}));
export default useCartStore;
